import { CardHeader } from "reactstrap";
import { ChevronDown, ChevronUp } from "react-feather";
import { Btn, H2 } from "../../../AbstractElements";
import { HeaderWithIconPropsTypes } from "../../../Type/JobSearch";

const HeaderWithIcon = ({ setIsOpen, isOpen, heading}: HeaderWithIconPropsTypes) => {
  return (
    <CardHeader id="headingOne" className="p-0">
      <H2 className="mb-0">
        <Btn className="w-100 btn-link btn-block text-start d-flex justify-content-between text-decoration-none" onClick={() => setIsOpen(!isOpen)} color="transperant">
          {heading}
          {isOpen ? <ChevronUp className="m-0" /> : <ChevronDown className="m-0" />}
        </Btn>
      </H2>
    </CardHeader>
  );
};

export default HeaderWithIcon;
